import { render, staticRenderFns } from "./GameThreat.vue?vue&type=template&id=84c88e2e&scoped=true"
import script from "./GameThreat.vue?vue&type=script&lang=js"
export * from "./GameThreat.vue?vue&type=script&lang=js"
import "./GameThreat.vue?vue&type=style&index=0&id=84c88e2e&prod&scoped=true&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c88e2e",
  null
  
)

export default component.exports